document.addEventListener('DOMContentLoaded', function () {
    const tabButtons = document.querySelectorAll('.custom-mega-menu__tab-btn');

    tabButtons.forEach(button => {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            // Find the parent mega menu
            const megaMenu = this.closest('.custom-mega-menu');
            if (!megaMenu) return;

            // Get the target tab ID
            const targetId = this.getAttribute('data-tab');
            const targetContent = megaMenu.querySelector('#' + targetId);

            if (!targetContent) return;

            // Remove active class from all buttons and contents in this mega menu
            const allButtons = megaMenu.querySelectorAll('.custom-mega-menu__tab-btn');
            const allContents = megaMenu.querySelectorAll('.custom-mega-menu__tab-content');

            allButtons.forEach(btn => btn.classList.remove('is-active'));
            allContents.forEach(content => content.classList.remove('is-active'));

            // Add active class to hovered button and its target content
            this.classList.add('is-active');
            targetContent.classList.add('is-active');
        });
    });

    const closeButtons = document.querySelectorAll('.custom-mega-menu__close');
    closeButtons.forEach(button => {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            const details = this.closest('details');
            if (details) {
                details.removeAttribute('open');
            }
        });
    });

    // Mobile slide-in drawers
    const mobileSubMenuToggles = document.querySelectorAll('.js-toggle-submenu');

    mobileSubMenuToggles.forEach(toggle => {
        toggle.addEventListener('click', function (e) {
            e.preventDefault();
            const targetId = this.getAttribute('aria-controls');
            if (targetId) {
                const targetDrawer = document.getElementById(targetId);
                if (targetDrawer) {
                    targetDrawer.classList.toggle('is-open');
                }
            } else {
                // Fallback for back buttons missing aria-controls
                const currentDrawer = this.closest('.mobile-nav__sub-drawer');
                if (currentDrawer) {
                    currentDrawer.classList.remove('is-open');
                }
            }
        });
    });

    // Mobile Mega Style 1 tabs
    const mobileTabButtons = document.querySelectorAll('.mobile-nav__mega-tab-btn');
    mobileTabButtons.forEach(button => {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            const megaMenu = this.closest('.mobile-nav__mega-style-1');
            if (!megaMenu) return;

            const targetId = this.getAttribute('data-tab');
            const targetContent = document.getElementById(targetId);

            if (!targetContent) return;

            const allButtons = megaMenu.querySelectorAll('.mobile-nav__mega-tab-btn');
            const allContents = megaMenu.querySelectorAll('.mobile-nav__mega-tab-content');

            allButtons.forEach(btn => btn.classList.remove('is-active'));
            allContents.forEach(content => content.classList.remove('is-active'));

            this.classList.add('is-active');
            targetContent.classList.add('is-active');
        });
    });
});
